import { Env } from "../env";

export const environment = {
    name: Env.QUALITY,
    host: 'https://fatmike.qa.brbl.it',
    graphqlUrl: 'https://tdxeejoc6zexbnfrw3i2rxobqa.appsync-api.eu-central-1.amazonaws.com/graphql',
    callMeBackApi: 'https://fatmike-operator.qa.brbl.it',
    barrettLink: 'https://d1z5r5blzdfbhp.cloudfront.net',
    cognito: {
        userPoolId: 'eu-central-1_POpFW1RIZ',
        clientId: '2iitb4s1co2nu1othhe29jih1a'
    },
    datadog: {
        applicationId: 'd830f08f-6e30-41cf-9656-ef5889b6bb2b',
        clientToken: 'pub8096389b8b62760ff59eacc8395dace8',
        enabled: true
    }
};
